import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { gettoken } from "../../Localstorage/Store";

export const addressApi = createApi({
  reducerPath: 'addressApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_API_URL}`, prepareHeaders: (headers, { getState }) => {
    const tokenvalue = gettoken();
    if (tokenvalue) {
      headers.set('Authorization',`Bearer ${tokenvalue.access}`);
    }
    return headers;
  },}),
  endpoints: (builder) => ({
    getAddressList: builder.query({
      query: () => ({
        url: `homepageapi/address/list`,
        method:'GET'
      }),
      providesTags: ['Addressapi']
    }),
    postCreateAddress: builder.mutation({
        query: (data) => ({
          url: `homepageapi/address/create/`,
          method:'POST',
          body:data
        }),
        invalidatesTags: ['Addressapi']
      }),

    putUpdateAddress: builder.mutation({
      query: ({ id,data }) => ({
        url: `homepageapi/address/${id}/update/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['Addressapi']
    }),
  }),
})

export const { useGetAddressListQuery,usePostCreateAddressMutation,usePutUpdateAddressMutation } = addressApi